// Frontend boot-perf logger. Mirrors `boot_perf::tick` on the Rust side.
//
// `[fe-perf] +<elapsed>ms <label>` lines are written to both the WebView
// console (so devtools shows the frontend timeline without needing the
// Tauri terminal) AND piped to Rust via the `app.perf_log` dispatch
// command (so the same lines land in the Tauri terminal log stream
// alongside `[startup-perf]` from boot_perf.rs).
//
// The Rust pipe is best-effort — early ticks fire before the SyncEngine
// is initialised and silently degrade to console-only.

import { invoke } from '@/sync/transports/promiseHandler';

const T0: number =
  (window as unknown as { __SONGBIRD_FE_T0__?: number }).__SONGBIRD_FE_T0__ ??
  performance.now();

export function fePerf(label: string): void {
  const elapsed = performance.now() - T0;
  // Match the Rust format ([startup-perf] +    1.2ms (Δ   1.2ms) label) so
  // the two streams scan visually as one timeline.
  // eslint-disable-next-line no-console
  console.log(`[fe-perf] +${elapsed.toFixed(1).padStart(7, ' ')}ms ${label}`);
  // Pipe to Rust via the raw Tauri bridge (`invoke`) — available as soon
  // as `tauri-bridge.js` populates `window.__SONGBIRD__`, which happens
  // synchronously in index.html before main.tsx runs. The typed `send`
  // path goes through SyncEngine, which isn't wired up until wiring.ts
  // finishes its module side effects, so early ticks would silently
  // reject. invoke() works immediately.
  try {
    void invoke('app.perf_log', { label, elapsedMs: elapsed }).catch(() => {});
  } catch {
    // No bridge (Vite-only dev without Tauri) — console line is enough.
  }
}
